/** PuppyCAD 离线包可持久化 CAD 数值的有效精度。 */
const PUPPY_CAD_NUMBER_SIGNIFICANT_DIGITS = 14

/** PuppyCAD 离线包将浮点噪声折叠为零或整数的绝对容差。 */
const PUPPY_CAD_NUMBER_SNAP_EPSILON = 1e-12

/**
 * 规范化离线包协议中的 CAD 浮点数。
 *
 * 设计说明：Three.js 的矩阵分解、四元数重组和 GLTFLoader 往返会产生约 1e-16 的 IEEE-754
 * 末位噪声。离线包必须在最终协议边界统一消除该噪声，不能让每个业务模块自行取整；
 * 14 位有效数字仍远高于当前 CAD 几何与交互容差，并为连续矩阵分解预留一位稳定裕量。
 *
 * @param value 待写入离线包 JSON 或 GLB JSON chunk 的有限数字。
 * @returns 可重复序列化的规范数字。
 */
export function canonicalizePuppyCadNumber(value: number): number {
  if (!Number.isFinite(value)) {
    throw new Error(`PuppyCAD 离线包 CAD 数值必须为有限数字：${String(value)}`)
  }
  if (Math.abs(value) <= PUPPY_CAD_NUMBER_SNAP_EPSILON) {
    return 0
  }

  const nearestInteger = Math.round(value)
  if (Math.abs(value - nearestInteger) <= PUPPY_CAD_NUMBER_SNAP_EPSILON) {
    return nearestInteger
  }

  return Number(value.toPrecision(PUPPY_CAD_NUMBER_SIGNIFICANT_DIGITS))
}
